import React from 'react'

import { red } from '@material-ui/core/colors'
import { createMuiTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'

const COLORS = {
    PRIMARY: 'rgb(6, 153, 221)',
    PRIMARY_DARK: '#003d5c',
    PRIMARY_LIGHT: '#33799c',
    PRIMARY_10: '#e5eef2',
    LIGHT_BACKGROUND: "#f6f9fb",
    DESTRUCTIVE: '#db0d17',
    NOT_ACTIVE: '#dbc10d',
    DARK: '#424242',
    OVERLAY: 'rgba(0, 61, 92, 0.5)',
    CANVAS: 'rgb(249, 250, 251)',
    DARK_65: 'rgba(0, 0, 0, 0.65)',
    DARK_10: 'rgba(0, 0, 0, 0.10)',
}
const ICONS_SIZE = 24
const theme = createMuiTheme({
    overrides: {
        MuiCssBaseline: {
            '@global': {
                html: {},
                body: {
                    backgroundColor: '#fff',
                    overscrollBehavior: 'none'
                },
                '.MuiAlert-root': {


                    '&.MuiAlert-standardError': {
                        '& svg': {
                            color: '#f44336 !important'
                        }
                    }
                },
                'form': {
                    width: '100%'
                },
                '.MuiDialogTitle-root': {
                    backgroundColor: `${COLORS.PRIMARY} !important`,

                },
                '.MuiTypography-h6': {
                    color: '#fff',
                    fontSize: 20,
                    lineHeight: '28px',
                    fontWeight: 500
                },
                '.MuiDialogContent-root .MuiGrid-container': {
                    padding: 20
                }
            }
        },
        MuiListItemIcon: {
            root: {
                color: '#fff'
            }
        },
        MuiDialogActions: {
            root: {
                padding: 0,
                justifyContent: 'flex-start'
            }
        },
        MuiChip: {
            root: {
                height: 'auto',
                color: '#fff',
                paddingLeft: 8,
                paddingRight: 8,
                borderRadius: 3,
                marginBottom: 8,
                backgroundColor: '#000'
            },
            label: {
                paddingLeft: 0,
                paddingRight: 0
            },
            colorSecondary: {
                backgroundColor: 'rgb(253, 195, 0)'
            }
        },
        MuiTablePagination: {
            root: {
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: 20
            }
        },
        MuiTypography: {
            h6: {
                color: '#fff'
            }
        },
        MuiTableCell: {
            root: {
                padding: '12px 0',
                borderBottomColor: COLORS.PRIMARY_10,
                '&:last-child': {
                    paddingRight: 0
                }
            },
            head: {
                color: COLORS.PRIMARY_LIGHT,
                fontWeight: 500,
                fontSize: 16,
                padding: '12px 0',
            }
        },
        MuiTableBody: {
            root: {
                color: COLORS.PRIMARY_LIGHT,
                fontSize: 16
            }
        },
        MuiBox: {
            root: {
                display: 'flex'
            }
        },
        MuiButton: {
            root: {
                textTransform: 'none',
                borderRadius: 2,
                padding: '10px 15px !important',
                boxShadow: 'none !important'
            },
            contained: {
                boxShadow: 'none !important'
            },
            label: {
                lineHeight: "16px",
                letterSpacing: 1.25,
                fontSize: 14,
                fontWeight: 500,
            },
        },
        MuiTypography: {
            body1: {
                fontWeight: 500,
                fontSize: 12,
                lineHeight: "14px"
            },
            body2: {
                fontWeight: 500,
                fontSize: 16
            },
            h2: {
                fontSize: 14,
                lineHeight: "18px",
                fontWeight: 500
            },
            h3: {
                fontSize: 20,
                fontWeight: 500
            },
            h6: {
                fontSize: 20,
                fontWeight: 500,
                lineHeight: '24px',
                color: COLORS.PRIMARY,
                letterSpacing: '0.15px'
            },
            button: {
                display: 'flex',
                color: COLORS.PRIMARY_LIGHT
            }
        },
        MuiCircularProgress: {
            svg: {
                width: 24,
                color: '#fff'
            },
            root: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 2
            },
        },
        MuiLinearProgress: {
            root: {
                width: '100%',
                borderRadius: 2
            },
            colorSecondary: {
                backgroundColor: COLORS.PRIMARY_10
            }
        },

        MuiCollapse: {
            container: {
                width: '100%'
            }
        },
        MuiList: {
            root: {
                width: '100%',
                cursor: 'pointer'
            }
        },
        MuiListItemText: {
            root: {
                marginTop: 0,
                marginBottom: 0
            }
        },
        MuiContainer: {
            maxWidthXl: {
                paddingRight: 0,
                paddingLeft: 0,
                maxWidth: '100% !important'
            },
            maxWidthMd: {
                paddingRight: 0,
                paddingLeft: 0
            }
        },
        MuiMenuItem: {
            root: {
                color: '#000000'
            }
        },
        MuiTabs: {
            root: {
                marginBottom: 20
            },
            flexContainer: {
                borderBottom: `2px solid ${COLORS.PRIMARY_10}`
            },
        },
        MuiDialog: {
            paperWidthSm: {
                maxWidth: 620
            }
        },
        MuiDialogTitle: {
            root: {
                backgroundColor: COLORS.PRIMARY_10,
                display: 'flex',
                alignItems: 'center',
                padding: '12px 20px',
                '& h3': {
                    fontSize: 20,
                    lineHeight: '24px',
                    color: '#fff',
                    flex: 1,
                },
                '& button': {
                    '& .MuiButton-label': {
                        lineHeight: '16px'
                    }
                }
            },
        },
        MuiDialogContent: {
            root: {
                padding: 0,
                '& .MuiGrid-container': {
                    paddingLeft: 20,
                    paddingRight: 20,
                },
                '&:first-child': {
                    paddingTop: 0
                }
            },

        },
        MuiFormControl: {
            root: {
                width: '100%'
            }
        },
        MuiToolbar: {
            root: {
                '& .MuiFormControl-root': {
                    width: 'auto'
                }
            }
        },
        MuiFormLabel: {
            root: {
                color: COLORS.PRIMARY_LIGHT
            }
        },
        MuiInput: {
            input: {
                color: COLORS.DARK
            }
        },
        MuiSelect: {
            root: {
                color: COLORS.PRIMARY_LIGHT
            }
        },
        MuiAppBar: {
            root: {
                boxShadow: 'none'
            },
        },
        MuiFab: {
            root: {
                boxShadow: 'none'
            }
        }
    },

    palette: {
        common: {
            black: '#000',
            white: '#fff',
        },
        primary: {
            main: COLORS.PRIMARY,
            dark: COLORS.PRIMARY_DARK,
            light: COLORS.PRIMARY_LIGHT,
            ultraLight: COLORS.PRIMARY_10,
            canvas: COLORS.CANVAS,
            dark65: COLORS.DARK_65,
            dark10: COLORS.DARK_10
        },
        secondary: {
            main: COLORS.DESTRUCTIVE,
            notActive: COLORS.NOT_ACTIVE
        },
        error: {
            main: red.A400,
        }
    },
    shape: {
        borderRadius: 2
    },
    font: {
        extraSmall: 10,
        small: 12,
        medium: 14,
        large: 16,
        weight: {
            normal: 400,
            medium: 500,
            bold: 700,
            black: 900
        }
    },
    padding: {
        extraSmall: 8,
        small: 12,
        medium: 20,
        large: 32,
        extraLarge: 40
    },
    margin: {
        extraSmall: 8,
        small: 12,
        medium: 20,
        large: 32,
        extraLarge: 40
    },
})

// Light theme
const lightTheme = createMuiTheme({
    ...theme,

})

const darkTheme = createMuiTheme({
    ...theme,

})

export const DefaultStyles = {
    AbsoluteFill: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'flex',
        minWidth: 760
    },
    CenterVertical: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    SingleLineLabel: {
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "pre"
    },
    PageContainer: {
        marginTop: 70,
    },
    MainTabContent: {
        badgeContainer: {
            display: 'flex',
            flex: 1
        },
        collapseTitle: {
            flex: 'inherit'
        },
        expendListItem: {
            paddingLeft: ICONS_SIZE + theme.padding.large,
            paddingTop: theme.padding.small,
            paddingBottom: theme.padding.small,
            backgroundColor: theme.palette.primary.ultraLight,
            borderBottomColor: theme.palette.common.white,
        }
    },
    ModalFields: {
        width: '100%',
        marginRight: theme.margin.large
    },
    TextEllipsis: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    SubModalForm: {
        formContainer: {
            width: '100%'
        },
        formTitle: {
            fontSize: 20,
            color: 'rgba(255, 255, 255, 0.87)',
        },
        formWrapper: {
            paddingTop: theme.padding.large,
            paddingBottom: theme.padding.extraLarge,
        },
        cancelButtonContainer: {
            display: 'flex',
            flex: 1
        },
    }
}

const withDarkTheme = (WrappedComponent) => {
    return class extends React.Component {
        render() {
            return (
                <ThemeProvider theme={darkTheme}>
                    <WrappedComponent {...this.props} />
                </ThemeProvider>
            )
        }
    }

}

const withLightTheme = (WrappedComponent) => {
    return class extends React.Component {
        render() {
            return (
                <ThemeProvider theme={lightTheme}>
                    <WrappedComponent {...this.props} />
                </ThemeProvider>
            )
        }
    }
}

export default lightTheme
export { darkTheme, lightTheme, COLORS, withLightTheme, withDarkTheme }
